import React from 'react';
import {
  useSelector,
} from 'react-redux';
import {
  FieldArrayRenderProps,
  useField,
} from 'formik';
import { StoreShape } from 'hellospa/redux/types';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';
import * as types from 'hellospa/page/prep-and-send/data/types';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from '../index.scss';
import messages from '../intl';
import PlusIcon from '../icons/plus';
import { ArrowDirection, TooltipPoint } from '../../../../foundation/control/tooltip';

const AddMeBtn = ({ helper }: { helper: FieldArrayRenderProps }) => {
  const intl = useIntl();
  const user = useSelector(selectors.getUser);
  const addSelfAsRecipient = useSelector(selectors.getSelfAsRecipient);
  const isEmbedded = useSelector(selectors.isEmbedded);
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);
  const [field] = useField<types.Recipient[]>('recipients');
  const [qesField] = useField<boolean>('qes');
  let disabled = false;

  if (qesField.value) {
    disabled = true;
  }

  // selector needs the recipients field
  const allowAdd = useSelector((state: StoreShape) => (
    selectors.allowRecipientAdd(state, field.value)
  ));

  // check if the current user is part of the recipients or not
  const hasSelfAsSigner = field.value.find((r) => (
    r.type === types.RecipientTypes.Signer
    && r.email.toLowerCase() === String(user.email).toLowerCase()
  ));

  // if it's embedded & not deep integration there's no need for a "ME"
  const embeddedSkipMe = isEmbedded && !isDeepIntegration;
  if (embeddedSkipMe || !allowAdd || !addSelfAsRecipient || hasSelfAsSigner) {
    return null;
  }

  // if there are no signers, then replace the first empty row
  // with ourself to the recipients list
  const addSelf = () => {
    // get the first recipient
    const r = field.value[0];
    if (r.type === types.RecipientTypes.Signer && (r.name === '' && r.email === '')) {
      helper.replace(0, addSelfAsRecipient);
      return;
    }

    // creates a new signer "row"
    helper.push(addSelfAsRecipient);
  };

  return (
    <Button
      type="button"
      kind={ButtonType.Subtle}
      disabled={disabled}
      onClick={addSelf}
      className={styles.addSigner}
      data-qa-ref="recipients.buttons.add_self"

    >
      {
        disabled
        && <TooltipPoint className={styles.tooltipUpBtn} arrow={ArrowDirection.Top}>
          <FormattedMessage id=''
            description='Disabled QES message'
            defaultMessage='Qualified eSignature is only available for one signer per document' />
        </TooltipPoint>
      }
      <PlusIcon className={styles.plusIcon} />
      {intl.formatMessage(messages.addSelfAsSignerButton)}
    </Button>
  );
};

export default AddMeBtn;
